import { List, Map } from 'immutable';
import { records as deviceRecords } from '@saucelabs/sl-module-devices-rdc';

import * as constants from './../constants';

const initialState = new Map({
  availableDeviceIds: {},
  detailsOpenDeviceId: null,
  items: new List(),
  loading: false,
  sessionAvailable: false,
  facets: null,
});

function isDisabled(device, state) {
  return !device.includedInPlan ||
    !state.get('availableDeviceIds')[device.dataCenterId] ||
    !state.get('availableDeviceIds')[device.dataCenterId].includes(device.descriptorId) ||
    !state.get('sessionAvailable');
}

function updateAll(state) {
  return state.update('items', (items) => new List(items.map((device) => device.set('disabled', isDisabled(device, state)))));
}

const sortResolutions = (resA, resB) => Number(resA.split('x')[0]) > Number(resB.split('x')[0]);

const sortNumericStrings = (el1, el2) => el1.localeCompare(el2, undefined, { numeric: true });

export const prepareFacets = (facets) => Object.entries(facets).reduce((acc, [facet, value]) => {
  if (facet === 'resolution') {
    return { ...acc, [facet]: Object.keys(value).sort(sortResolutions) };
  }

  if (facet === 'osVersion' || facet === 'screenSize') {
    return { ...acc, [facet]: Object.keys(value).sort(sortNumericStrings).reverse() };
  }

  return { ...acc, [facet]: Object.keys(value).sort() };
}, {});

const devicesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.MOBILE_DEVICES_FETCH.REQUEST:
      return state.set('loading', true);
    case constants.MOBILE_DEVICES_FETCH.SUCCESS: {
      const payloadItems = payload.entities || [];
      const items = new List(
        payloadItems.map((device) => new deviceRecords.DeviceDescriptor(device)),
      );
      return updateAll(
        state
          .set('loading', false)
          .set('items', items)
          .update('facets', (facets) => facets || (payload.facets && prepareFacets(payload.facets)) || null),
      );
    }
    case constants.MOBILE_DEVICES_FETCH.FAILURE:
      return state.set('loading', false);
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.SUCCESS:
      return updateAll(state.set('availableDeviceIds', payload));
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.FAILURE:
      return updateAll(state.set('availableDeviceIds', initialState.get('availableDeviceIds')));
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.SUCCESS:
      return updateAll(state.set('sessionAvailable', payload.manualSessionAvailable));
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.FAILURE:
      return updateAll(state.set('sessionAvailable', initialState.get('sessionAvailable')));
    case constants.MOBILE_DEVICE_TILE_DETAILS_OPEN:
      return state.set('detailsOpenDeviceId', payload);
    case constants.MOBILE_DEVICE_TILE_DETAILS_CLOSE:
      return state.set('detailsOpenDeviceId', initialState.get('detailsOpenDeviceId'));
    case constants.MOBILE_DEVICES_FACETS_CLEANUP:
      return state.set('facets', initialState.get('facets'));
    default:
      return state;
  }
};

export default devicesReducer;
export { initialState };
